export const DEFAULT_SITE_NAME = 'Ecommerce'

export const DEFAULT_DESCRIPTION =
  'Scopri prodotti, categorie e offerte aggiornate nel nostro catalogo online.'
